module.exports = __webpack_public_path__ + "assets/img/yjjy.d7833172.png";